//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import PlayIcon from '../../images/Play.svg';


export default {
	data() {
		return {
			isModalOpen: false,
			play_button: PlayIcon,
		};
	},

	props: {
		poster: {
			type: String,
			default: '',
		},
		source_video: {
			type: String,
			default: '',
		},
	},

	computed: {},

	watch: {},

	methods: {
		modalOpen() {
			this.sourceVideo = this.source_video;
			this.isModalOpen = true;
		},

		modalClose() {
			this.sourceVideo = '';
			this.isModalOpen = false;
		},
	},

	components: {},

	created() {},
	mounted() {},
};



// WEBPACK FOOTER //
// ./scripts/vue/VideoModal.vue